import isEmpty from 'lodash/isEmpty';

const splitName = data => {
  // app/javascript/javascripts/pages/common/form/vuex/store.js をベースにnameにスコープをあてて実装
  const name = data['name'];
  const firstName = data['first_name'];
  const lastName = data['last_name'];

  if (name && name.split(/\s/).length > 0) {
    return {
      name: name,
      last_name: name.split(/\s/)[0],
      first_name: name.split(/\s/)[1]
    };
  } else if (firstName && lastName) {
    return {
      name: `${firstName} ${lastName}`,
      first_name: firstName,
      last_name: lastName
    };
  } else {
    return {
      name: name || '',
      first_name: '',
      last_name: ''
    };
  }
};

const splitNameKana = data => {
  // app/javascript/javascripts/pages/common/form/vuex/store.js をベースにname_kanaにスコープをあてて実装
  const nameKana = data['name_kana'];
  const firstNameKana = data['first_name_kana'];
  const lastNameKana = data['last_name_kana'];

  if (nameKana && nameKana.split(/\s/).length > 0) {
    return {
      name_kana: nameKana,
      last_name_kana: nameKana.split(/\s/)[0],
      first_name_kana: nameKana.split(/\s/)[1]
    };
  } else if (firstNameKana && lastNameKana) {
    return {
      name_kana: `${firstNameKana} ${lastNameKana}`,
      first_name_kana: firstNameKana,
      last_name_kana: lastNameKana
    };
  } else {
    return {
      name_kana: nameKana || '',
      first_name_kana: '',
      last_name_kana: ''
    };
  }
};

const state = {
  formData: {
    name: undefined,
    name_kana: undefined,
    last_name: undefined,
    first_name: undefined,
    last_name_kana: undefined,
    first_name_kana: undefined,
    email: undefined,
    prefecture_id: undefined,
    address: undefined,
    phone: undefined,
    sex: undefined,
    age: undefined,
    wishful_time: undefined,
    work_status: undefined,
    m3_registeration: false,
    experiences_attributes: {},
    message: undefined,
    kind: '',
    test_type: 'pc_new',
    qualified: null,
    work_experiece: null
  }
};

const actions = {
  initFormData({ state, dispatch }, initialData) {
    Object.keys(state.formData).map(key => {
      if (
        initialData[key] !== null &&
        typeof initialData[key] !== 'undefined'
      ) {
        dispatch('setFormItem', { field: key, value: initialData[key] });
      }
    });
    const nameProperties = splitName(initialData);
    dispatch('setFormItem', { field: 'name', value: nameProperties.name });
    dispatch('setFormItem', {
      field: 'first_name',
      value: nameProperties.first_name
    });
    dispatch('setFormItem', {
      field: 'last_name',
      value: nameProperties.last_name
    });

    const nameKanaProperties = splitNameKana(initialData);
    dispatch('setFormItem', {
      field: 'name_kana',
      value: nameKanaProperties.name_kana
    });
    dispatch('setFormItem', {
      field: 'first_name_kana',
      value: nameKanaProperties.first_name_kana
    });
    dispatch('setFormItem', {
      field: 'last_name_kana',
      value: nameKanaProperties.last_name_kana
    });

    dispatch('setFormItem', {
      field: 'message',
      value:
        '掲載中の求人情報に、たいへん興味を持っております。 是非一度、お話をお伺いする機会をいただければと思っております。'
    });

    // 経験年数はネスト化している
    const initialExperiencesAttributes = {};
    if (!isEmpty(initialData.experience_position_type)) {
      initialExperiencesAttributes[0] = {
        position_type: initialData.experience_position_type,
        year: initialData.experience_year
      };
    }
    if (!isEmpty(initialData.experience_position_type2)) {
      initialExperiencesAttributes[1] = {
        position_type: initialData.experience_position_type2,
        year: initialData.experience_year2
      };
    }
    if (!isEmpty(initialData.experience_position_type3)) {
      initialExperiencesAttributes[2] = {
        position_type: initialData.experience_position_type3,
        year: initialData.experience_year3
      };
    }
    if (Object.keys(initialExperiencesAttributes).length > 0) {
      dispatch('setFormItem', {
        field: 'experiences_attributes',
        value: initialExperiencesAttributes
      });
    }
  },
  setFormItem({ commit }, { field, value }) {
    commit('SET_FORM_ITEM', { field, value });
  },
  setMessage({ commit }, value) {
    commit('SET_FORM_ITEM', { field: 'message', value });
  },
  setFirstName({ commit }, value) {
    commit('SET_FORM_ITEM', { field: 'first_name', value });
  },
  setLastName({ commit }, value) {
    commit('SET_FORM_ITEM', { field: 'last_name', value });
  },
  setFirstNameKana({ commit }, value) {
    commit('SET_FORM_ITEM', { field: 'first_name_kana', value });
  },
  setLastNameKana({ commit }, value) {
    commit('SET_FORM_ITEM', { field: 'last_name_kana', value });
  },
  setEmail({ commit }, value) {
    commit('SET_FORM_ITEM', { field: 'email', value });
  },
  setPrefectureId({ commit }, value) {
    commit('SET_FORM_ITEM', { field: 'prefecture_id', value });
  },
  setAddress({ commit }, value) {
    commit('SET_FORM_ITEM', { field: 'address', value });
  },
  setPhone({ commit }, value) {
    commit('SET_FORM_ITEM', { field: 'phone', value });
  },
  setSex({ commit }, value) {
    commit('SET_FORM_ITEM', { field: 'sex', value });
  },
  setAge({ commit }, value) {
    commit('SET_FORM_ITEM', { field: 'age', value });
  },
  setWishfulTime({ commit }, value) {
    commit('SET_FORM_ITEM', { field: 'wishful_time', value });
  },
  setWorkStatus({ commit }, value) {
    commit('SET_FORM_ITEM', { field: 'work_status', value });
  },
  setMessage({ commit }, value) {
    commit('SET_FORM_ITEM', { field: 'message', value });
  }
};

const mutations = {
  SET_FORM_ITEM(state, { field, value }) {
    state.formData[field] = value;
  }
};

export default { namespaced: true, state: () => state, actions, mutations };
